module.exports = __webpack_public_path__ + "static/media/users-b.0013b7f6.svg";